import { TransactionCategoryModel } from 'api-hooks/transaction-category';
import React from 'react';

import { TransactionCategoryFormType } from '../components/form-type';

export default function useTransactionCategoryDefaultValues(
  transactionCategory?: TransactionCategoryModel,
): TransactionCategoryFormType {
  const defaultValues = React.useMemo<TransactionCategoryFormType>(() => {
    return {
      name: transactionCategory?.name || '',
      paymentChannel: transactionCategory,
    };
  }, [transactionCategory]);
  return defaultValues;
}
